<template>
  <figure style="width: 100%; height: 100%;display: flex;align-items: center;justify-content: center;">
    <chart :options="graphOptions" @click="entityFilter" ref="graph" auto-resize style='width: 100%; height: 100%' v-if="dataState === 'ready'"></chart>
    <template v-else-if="dataState === 'loading'">
      <center>
        <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </center>
    </template>
    <template v-else-if="dataState === 'noData'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="primary--text" style="font-size: 40px !important;width:100%">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">no data found</p></div>
    </template>
    <template v-else-if="dataState === 'error'">
      <div class="d-flex" style="flex-direction: column; align-items: center"><v-icon class="error--text" style="font-size: 40px !important">warning</v-icon><p class="accent--text mb-0 ml-2 subheading font-weight-bold">error connecting to server</p></div>
    </template>
  </figure>
</template>

<script>
import axios from 'axios'
import underscore from 'underscore'
import { mapGetters, mapMutations } from 'vuex'
import 'echarts/lib/chart/graph'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dataState: 'loading',
      graphOptions: {
        tooltip: {},
        legend: [ { data: [] } ],
        animationDurationUpdate: 1500,
        animationEasingUpdate: 'quinticInOut',
        series: [
          {
            type: 'graph',
            layout: this.options.layout,
            roam: true,
            focusNodeAdjacency: true,
            data: [],
            links: [],
            categories: [],
            label: {
              normal: {
                position: 'right',
                formatter: '{b}'
              }
            },
            draggable: true,
            lineStyle: {
              normal: {
                color: 'source',
                curveness: 0.3
              }
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('filters', ['getQuery', 'getEntity']),
    filterEntity: function () {
      return this.getEntity
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setCustomFilters', 'resetEntityFilter']),
    entityFilter: function (word) {
      if (word && word.name.indexOf('<') === -1 && word.name.indexOf('>') === -1) {
        word = word.name.substr(1, word.name.length)
        var filter = this.filterEntity.slice()
        var index = filter.indexOf(word)
        if (index >= 0) {
          filter.splice(index, 1)
          this.setCustomFilters({entity: filter})
        } else {
          filter.push(word)
          this.setCustomFilters({entity: filter})
        }
      }
    },
    getData: function () {
      this.dataState = 'loading'
      axios.all([
        this.$store.dispatch('getTweetsVirtualEntitiesWithRelatedEntities', this.getQuery({pageSize: this.options.pageSize, sortBy: this.options.sortBy, order: 'DESC'}))
      ]).then(axios.spread((r1) => {
        if (r1.data.status === 'SUCCESS') {
          let categories = []
          let links = []
          let nodes = []
          let max = Number.MIN_VALUE
          if (r1.data.payload.length === 0) {
            this.dataState = 'noData'
          } else {
            for (let i = 0; i < r1.data.payload.length; i++) {
              if (max < r1.data.payload[i].tweetCount) {
                max = r1.data.payload[i].tweetCount
              }
              let relatedNames = []
              if (r1.data.payload[i].related) {
                relatedNames = r1.data.payload[i].related
              }
              if (categories.length === 0) {
                categories.push({names: relatedNames, max: {count: r1.data.payload[i].tweetCount, name: r1.data.payload[i].name}})
              } else {
                let in_ = false
                for (let j = 0; j < categories.length && !in_; j++) {
                  if (new Set([...relatedNames].filter(x => categories[j].names.indexOf(x) !== -1)).size === relatedNames.length) {
                    in_ = true
                  }
                }
                if (!in_) {
                  categories.push({names: relatedNames, max: {count: r1.data.payload[i].tweetCount, name: r1.data.payload[i].name}})
                }
              }
              for (let j = 0; j < relatedNames.length; j++) {
                if (r1.data.payload[i].name !== relatedNames[j]) {
                  links.push({target: relatedNames[j], source: r1.data.payload[i].name})
                }
              }
            }
            for (let i = 0; i < links.length; i++) {
              for (let j = i + 1; j < links.length; j++) {
                if (links[i].target === links[j].source && links[j].target === links[i].source) {
                  links.splice(j, 1)
                  j = j - 1
                }
              }
            }
            for (let i = 0; i < r1.data.payload.length; i++) {
              let in_ = false
              for (let x = 0; x < categories.length; x++) {
                if (categories[x].names.indexOf(r1.data.payload[i].name) !== -1 && in_ === false) {
                  in_ = x
                }
              }
              if (in_ !== false) {
                let x = in_
                nodes.push({symbolSize: Math.ceil((r1.data.payload[i].tweetCount - 1) / (max - 1) * (50 - 5) + 5), label: { normal: { show: true } }, itemStyle: null, category: categories[x].max.name, attributes: {modularity_class: categories[x].max.name}, id: r1.data.payload[i].name, name: r1.data.payload[i].name, value: r1.data.payload[i].tweetCount})
              }
            }
            nodes = nodes.slice(0, this.options.pageSize)
            for (let j = 0; j < nodes.length; j++) {
              let in_ = false
              for (let i = 0; i < links.length; i++) {
                if ([links[i].source, links[i].target].indexOf(nodes[j].id) !== -1) {
                  in_ = true
                }
              }
              if (!in_ && this.options.singles !== 'singles') {
                nodes.splice(j, 1)
                j = j - 1
              }
            }
            for (let i = 0; i < categories.length; i++) {
              let in_ = false
              for (let j = 0; j < nodes.length; j++) {
                if (categories[i].max.name.indexOf(nodes[j].category) !== -1) {
                  in_ = true
                }
              }
              if (!in_) {
                categories.splice(i, 1)
                i = i - 1
              }
            }
            this.graphOptions.series[0].layout = this.options.layout
            if (this.options.layout === 'force') {
              this.graphOptions.series[0].force = { repulsion: 200, edgeLength: 100, gravity: 0.2 }
            } else {
              this.graphOptions.series[0].circular = { rotateLabel: true }
            }
            this.graphOptions.legend[0].data = categories.map(function (a) { return a.max.name })
            this.graphOptions.series[0].data = nodes
            this.graphOptions.series[0].links = links
            this.graphOptions.series[0].categories = categories.map(function (a) { return { name: a.max.name } })
            if (links.length >= 0 && nodes.length > 0) {
              this.dataState = 'ready'
            } else {
              this.dataState = 'noData'
            }
          }
        } else {
          this.dataState = 'error'
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.dataState = 'error'
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    },
    options: {
      deep: true,
      immediate: true,
      handler (newVal, oldVal) {
        if (oldVal && newVal && !underscore.isEqual(newVal, oldVal) && this.filters.dirty === false) {
          this.getData()
        }
      }
    },
    loading: {
      immediate: true,
      handler (newVal, oldVal) {
        if (newVal === true) {
          let graph = this.$refs.graph
          if (graph) {
            graph.showLoading({
              text: '',
              color: '#4ea397',
              maskColor: 'rgba(255, 255, 255, 0.4)'
            })
          }
        } else {
          let graph = this.$refs.graph
          if (graph) {
            graph.hideLoading()
          }
        }
      }
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/EntityRelatedGraphChart.vue